export default (storeState, {payload}) => {
  let newState = Object.assign({}, storeState);
  newState.newsCategories = payload;

  return newState;
};
